import { useState } from 'react'
import './PWAInstallPrompt.scss'

const PWAInstallPrompt = ({ onClose, onInstall }) => {
  const [showIOSGuide, setShowIOSGuide] = useState(false)
  const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream
  const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent)

  // Détection du in-app browser
  const isInAppBrowser = () => {
    const ua = navigator.userAgent
    return /FBAN|FBAV|FB_IAB|Instagram|WhatsApp|Messenger|Line|WeChat|QQ|Alipay|UCBrowser|QihooNewsReader|SogouMSE|SogouNewsReader|SogouZSZ|baiduboxapp|iQiyi|Quark|WKWebviewWrapper/i.test(
      ua,
    )
  }

  const isInApp = isInAppBrowser()

  const copyToClipboard = () => {
    navigator.clipboard.writeText('https://ogc.laguindaws.com').then(() => {
      alert('Lien copié ! Collez-le dans un navigateur normal.')
    })
  }

  return (
    <div className='pwa-overlay'>
      <div className='pwa-modal'>
        <button className='pwa-close' onClick={onClose} aria-label='Fermer'>
          <svg
            width='24'
            height='24'
            viewBox='0 0 24 24'
            fill='none'
            stroke='currentColor'
          >
            <path
              strokeLinecap='round'
              strokeLinejoin='round'
              strokeWidth={2}
              d='M6 18L18 6M6 6l12 12'
            />
          </svg>
        </button>

        {isInApp ? (
          <>
            <div className='pwa-icon'>
              <svg width='64' height='64' viewBox='0 0 64 64' fill='none'>
                <rect width='64' height='64' rx='16' fill='url(#gradient2)' />
                <path
                  d='M32 20v24M20 32h24'
                  stroke='white'
                  strokeWidth='4'
                  strokeLinecap='round'
                />
                <defs>
                  <linearGradient id='gradient2' x1='0' y1='0' x2='64' y2='64'>
                    <stop offset='0%' stopColor='#FF6B6B' />
                    <stop offset='100%' stopColor='#FF8E53' />
                  </linearGradient>
                </defs>
              </svg>
            </div>

            <h2 className='pwa-title'>Ouvrez le lien dans Google</h2>
            <p className='pwa-description'>
              Pour installer l'application, veuillez ouvrir ce lien dans un
              navigateur normal.
            </p>

            <div className='pwa-inapp-info'>
              <p className='pwa-info-text'>
                Copiez le lien ci-dessous et ouvrez-le dans Google, Safari,
                Chrome ou Opera.
              </p>

              <div className='pwa-link-box'>
                <div>
                  <span className='pwa-link-text'>
                    https://ogc.laguindaws.com
                  </span>
                </div>

                <button
                  className='pwa-copy-button'
                  onClick={copyToClipboard}
                  aria-label='Copier le lien'
                >
                  Copier
                </button>
              </div>
            </div>

            <button
              className='pwa-button pwa-button-secondary'
              onClick={onClose}
            >
              Fermer
            </button>
          </>
        ) : !showIOSGuide ? (
          <>
            <div className='pwa-icon'>
              <svg width='64' height='64' viewBox='0 0 64 64' fill='none'>
                <rect width='64' height='64' rx='16' fill='url(#gradient)' />
                <path
                  d='M32 20v24M20 32h24'
                  stroke='white'
                  strokeWidth='4'
                  strokeLinecap='round'
                />
                <defs>
                  <linearGradient id='gradient' x1='0' y1='0' x2='64' y2='64'>
                    <stop offset='0%' stopColor='#667eea' />
                    <stop offset='100%' stopColor='#764ba2' />
                  </linearGradient>
                </defs>
              </svg>
            </div>

            <h2 className='pwa-title'>Installez l'application</h2>
            <p className='pwa-description'>
              Accédez rapidement à votre espace depuis votre écran d'accueil.
              Profitez d'une expérience optimale, même hors ligne.
            </p>

            <div className='pwa-features'>
              <div className='pwa-feature'>
                <svg
                  width='24'
                  height='24'
                  viewBox='0 0 24 24'
                  fill='none'
                  stroke='currentColor'
                >
                  <path
                    strokeLinecap='round'
                    strokeLinejoin='round'
                    strokeWidth={2}
                    d='M13 10V3L4 14h7v7l9-11h-7z'
                  />
                </svg>
                <span>Accès rapide</span>
              </div>
              <div className='pwa-feature'>
                <svg
                  width='24'
                  height='24'
                  viewBox='0 0 24 24'
                  fill='none'
                  stroke='currentColor'
                >
                  <path
                    strokeLinecap='round'
                    strokeLinejoin='round'
                    strokeWidth={2}
                    d='M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z'
                  />
                </svg>
                <span>Mode hors ligne</span>
              </div>
              <div className='pwa-feature'>
                <svg
                  width='24'
                  height='24'
                  viewBox='0 0 24 24'
                  fill='none'
                  stroke='currentColor'
                >
                  <path
                    strokeLinecap='round'
                    strokeLinejoin='round'
                    strokeWidth={2}
                    d='M12 18h.01M8 21h8a2 2 0 002-2V5a2 2 0 00-2-2H8a2 2 0 00-2 2v14a2 2 0 002 2z'
                  />
                </svg>
                <span>Interface native</span>
              </div>
            </div>

            {isIOS && isSafari ? (
              <button
                className='pwa-button pwa-button-primary'
                onClick={() => setShowIOSGuide(true)}
              >
                Voir le guide iOS
              </button>
            ) : (
              <button
                className='pwa-button pwa-button-primary'
                onClick={onInstall}
              >
                Installer maintenant
              </button>
            )}

            <button
              className='pwa-button pwa-button-secondary'
              onClick={onClose}
            >
              Plus tard
            </button>
          </>
        ) : (
          <>
            <div className='pwa-icon'>
              <svg width='64' height='64' viewBox='0 0 64 64' fill='none'>
                <rect width='64' height='64' rx='16' fill='#007AFF' />
                <path
                  d='M32 16c-4.4 0-8 3.6-8 8 0 6 8 12 8 12s8-6 8-12c0-4.4-3.6-8-8-8zm0 11c-1.7 0-3-1.3-3-3s1.3-3 3-3 3 1.3 3 3-1.3 3-3 3z'
                  fill='white'
                />
                <path d='M20 42h24v4H20z' fill='white' />
                <path
                  d='M28 36l4-4 4 4'
                  stroke='white'
                  strokeWidth='2'
                  fill='none'
                />
              </svg>
            </div>

            <h2 className='pwa-title'>Installation sur iOS</h2>
            <p className='pwa-description'>Suivez ces étapes simples :</p>

            <div className='pwa-ios-steps'>
              <div className='pwa-step'>
                <div className='pwa-step-number'>1</div>
                <div className='pwa-step-content'>
                  <strong>Appuyez sur le bouton Partager</strong>
                  <span>
                    <svg
                      width='20'
                      height='20'
                      viewBox='0 0 20 20'
                      fill='#007AFF'
                    >
                      <path d='M10 0L6 4h3v8h2V4h3L10 0zM2 8v10h16V8h-2v8H4V8H2z' />
                    </svg>
                    en bas de l'écran Safari
                  </span>
                </div>
              </div>

              <div className='pwa-step'>
                <div className='pwa-step-number'>2</div>
                <div className='pwa-step-content'>
                  <strong>Sélectionnez "Sur l'écran d'accueil"</strong>
                  <span>Faites défiler et trouvez cette option</span>
                </div>
              </div>

              <div className='pwa-step'>
                <div className='pwa-step-number'>3</div>
                <div className='pwa-step-content'>
                  <strong>Appuyez sur "Ajouter"</strong>
                  <span>
                    L'application apparaîtra sur votre écran d'accueil
                  </span>
                </div>
              </div>
            </div>

            <button className='pwa-button pwa-button-primary' onClick={onClose}>
              J'ai compris
            </button>
            <button
              className='pwa-button pwa-button-secondary'
              onClick={() => setShowIOSGuide(false)}
            >
              Retour
            </button>
          </>
        )}
      </div>
    </div>
  )
}

export default PWAInstallPrompt
